<template>
    <b-form>
        <b-row class="mb-2">
            <!-- Empresa -->
            <b-col cols="12" md="3" class="form-group" v-if="viewFilterCompany">
                <label for="id_empresa">Empresa</label>
                <el-select id="empresa" name="empresa" filterable clearable
                           v-model="filter.company_id"
                           placeholder="Seleccione una opción"
                           @change="changeCompany(filter.company_id)" size="medium" remote
                           :remote-method="searchCompany">
                    <el-option v-for="empresa in empresas" :key="empresa.id"
                               :label="empresa.nombre" :value="empresa.id" />
                </el-select>
            </b-col>

            <!-- Ubicación -->
            <b-col cols="12" md="3" class="form-group">
                <label for="id_ubicacion">Ubicación</label>
                <tree-select v-model="filter.slq_location_id" id="ubicacion" name="ubicacion"
                             :multiple="false" :defaultExpandLevel="Infinity"
                             :options="ubicaciones" :disabled="!filter.company_id"
                             placeholder="Selecciona una ubicación" />
            </b-col>

            <!-- Rango de fechas -->
            <b-col cols="12" md="3" class="form-group">
                <label for="range_date">Fechas</label>
                <el-date-picker v-model="filter.date_report" id="range_date" name="range_date"
                                type="daterange" range-separator="a" value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd" :start-placeholder="from" :end-placeholder="to"
                                :picker-options="pickerOptions" class="w-100" size="medium">
                </el-date-picker>
            </b-col>

            <!-- Uso -->
            <b-col cols="12" md="3" class="form-group">
                <label for="in_use">Disponibilidad en inventario</label>
                <el-select id="in_use" name="in_use" filterable clearable
                           v-model="filter.in_use" placeholder="Seleccione una opción"
                           size="medium">
                    <el-option label="Si" :value="1" />
                    <el-option label="No" :value="0" />
                </el-select>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import TreeSelect from "@riophae/vue-treeselect";
import { mapActions, mapMutations, mapState } from "vuex";
import { validarPermisoComponente } from "@/plugins/acl";
import moment from "moment";

export default {
    name: "FormSearch",
    components: { TreeSelect },
    data() {
        return {
            filter: {
                company_id: null,
                slq_location_id: null,
                date_report: null,
                in_use: 1,
            },
            from: moment().subtract(5, "year").format("YYYY-MM-DD"),
            to: moment().format("YYYY-MM-DD"),
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    const fiveYearsAgo = new Date();
                    fiveYearsAgo.setFullYear(today.getFullYear() - 5);
                    return (
                        time.getTime() > today.getTime() ||
                        time.getTime() < fiveYearsAgo.getTime()
                    );
                },
            },
            validarPermisoComponente: validarPermisoComponente,
            viewFilterCompany: false,
        };
    },
    async created() {
        this.load(false);
        if (this.validarPermisoComponente(["ver-dashboard-todas-las-empresas"])) {
            this.viewFilterCompany = true;
        } else {
            this.viewFilterCompany = false;
            this.filter.company_id = await this.obtenerIdEmpresaUsuario();
        }
        // Inicializa los filtros en el estado Vuex al cargar el componente
        this.setDashboardFilters(this.filter);
    },
    methods: {
        ...mapActions("tareas", ["obtenerEmpresas", "obtenerUbicaciones"]),
        ...mapActions("dashboard", [
            "findDataDash1",
            "obtenerIdEmpresaUsuario",
            "findDataDash1Priority",
            "findDataDash2",
        ]),
        ...mapMutations("dashboard", [
            "load",
            "resetDataDash1Consulted",
            "resetDataDash2Consulted",
            "setDashboardFilters",
            "resetDashboardFilters"
        ]),

        async clearFilter() {
            this.filter = {
                company_id: this.viewFilterCompany
                    ? null
                    : await this.obtenerIdEmpresaUsuario(),
                slq_location_id: null,
                date_report: null,
                in_use: null,
            };
            this.resetDashboardFilters();
            this.resetDataDash1Consulted();
            this.resetDataDash2Consulted();
            await this.searchInfo();
            // Actualiza los filtros en Vuex después de limpiar
            this.setDashboardFilters(this.filter);
        },

        async searchInfo() {
            this.$emit("handle-loading", true);
            if (this.filter.company_id) {
                if (this.screens.accident && !this.dataDash1.consulted) {
                    await this.findDataDash1(this.filter);
                    const payloadAri = {
                        company_id: this.filter.company_id,
                        products_ids: (this.filter.slq_location_id || this.filter.date_report || this.filter.in_use)
                            ? this.dataDash1.product_company_ids
                            : [],
                    };
                    await this.findDataDash1Priority(payloadAri);
                }
                if (this.screens.health && !this.dataDash2.consulted) {
                    await this.findDataDash2(this.filter);
                }
            }
            this.$emit("handle-loading", false);
        },

        async changeCompany() {
            await this.obtenerUbicaciones(this.filter.company_id);
            this.filter.slq_location_id = null;
            this.resetDataDash1Consulted();
            this.resetDataDash2Consulted();
            await this.searchInfo();
            // Actualiza los filtros en Vuex tras cambiar la empresa
            this.setDashboardFilters(this.filter);
        },

        async searchCompany(val) {
            await this.obtenerEmpresas(val);
        },
    },
    computed: {
        ...mapState("tareas", ["ubicaciones", "empresas"]),
        ...mapState("dashboard", ["screens", "dataDash1", "dataDash2", "dashboardFilters"]),
    },
    watch: {
        "filter.company_id": async function (val) {
            if (!val) {
                await this.clearFilter();
                this.$emit("company-id-changed", null);
                return;
            } else {
                await this.obtenerUbicaciones(val);
                this.filter.slq_location_id = null;
                this.resetDataDash1Consulted();
                this.resetDataDash2Consulted();
                await this.searchInfo();
                this.$emit("company-id-changed", val);
            }
            // Actualiza los filtros en Vuex cada vez que company_id cambie
            this.setDashboardFilters(this.filter);
        },

        "filter.slq_location_id": async function (val) {
            if (!val) {
                this.filter.slq_location_id = null;
            }
            this.resetDataDash1Consulted();
            this.resetDataDash2Consulted();
            await this.searchInfo();
            // Actualiza los filtros en Vuex cada vez que slq_location_id cambie
            this.setDashboardFilters(this.filter);
        },

        "filter.date_report": async function (val) {
            if (!val) {
                this.filter.date_report = null;
            }
            this.resetDataDash1Consulted();
            this.resetDataDash2Consulted();
            await this.searchInfo();
            // Actualiza los filtros en Vuex cada vez que date_report cambie
            this.setDashboardFilters(this.filter);
        },

        "filter.in_use": async function (val) {
            if (val === null) {
                this.filter.in_use = null;
            }
            this.resetDataDash1Consulted();
            this.resetDataDash2Consulted();
            await this.searchInfo();
            // Actualiza los filtros en Vuex cada vez que in_use cambie
            this.setDashboardFilters(this.filter);
        },

        screens: {
            handler: async function () {
                await this.searchInfo();
            },
            deep: true,
        },
    },
};
</script>

<style src="./../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
<style>
.vue-treeselect__no-children-tip {
    display: none !important;
}
.vue-treeselect__control {
    min-height: 30px !important;
    font-size: 14px !important;
}
.imagen-checkbox {
    box-shadow: 0 0 3px #b8b8b8;
}
.is-checked .imagen-checkbox {
    box-shadow: 0px 1px 10px #097b83;
    border: 1px solid #097b83;
}
.checkbox-imagen .el-radio__input {
    display: none;
}
</style>
